const people = [
  {
    url: "/images/bg6.jpg",
    text: "Shop Your Style",
    desc: "Sofete Store offers quality shirts with unique designs that makes a classic person like you stand out. ",
    btn: "Shop Now",
    caption: "Explore Your True Style",
    id: 1,
  },
  {
    id: 2,
    url: "/images/bg4.jpg",
    text: "Fashion As Unique As You Are",
    desc: "We give you the best deal for the best quality of vintage shirts. Feel at home and shop with convinience on our website.",
    caption: "Try it, Wear it, Love it",
    btn: "Get started",
  },
  {
    url: "/images/bg7.jpg",
    text: "Clothes That Shines You",
    desc: "Helping you to be more fashionable, giving you exclusive fabrics with elegant designs to bloom your elegance. ",
    btn: "Explore",
    caption: "Your Fashion Defines You",
    id: 3,
  },
];

export default people;
